/**
 * Created by Ning Jiang on 11/24/2016.
 */

import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";

export class IceIceYetiSoundConfig implements ISoundConfig {

    public static instance:IceIceYetiSoundConfig = new IceIceYetiSoundConfig();
    AS_WIN:string="asWin";
    AS_WIN_BIG:string="asWinBig";
    RESPIN_BACKGROUND:string = "bgMusicRespin";
    SPIN_LOOPS:string[] = ["spin1", "spin2", "spin3", "spin4", "spin5", "spin6", "spin7"];

    AMBIENT:string = "ambient";
    REELS_SPINNING_START_ON_SPIN_START:string = "wheels-spinning";
    REELS_DEFAULT_BOUNCE:string[] = ["reel-one-landing", "reel-two-landing", "reel-three-landing", "reel-four-landing", "reel-five-landing"];
    WIN_TINY:string = "winTiny";
    WIN_SMALL:string = "winSmall";
    WIN_MEDIUM:string = "winMedium";
    WIN_LARGE:string = "winLarge";
    BIG_WIN_LEVEL_01:string = "bigwin1";
    BIG_WIN_LEVEL_02:string = "bigwin2";
    BIG_WIN_LEVEL_03:string = "bigwin3";
    BIG_WIN_ENDS_01:string = "bigwinEnds1";
    BIG_WIN_ENDS_02:string = "bigwinEnds2";
    BIG_WIN_ENDS_03:string = "bigwinEnds3";
    COUNTUP:string = "countup";
    COUNTUP_ENDS:string = "countupEnds";
    ICE_CRACKING:string = "iceCracking";
    ICE_EXPLODING:string = "iceExploding";
    ICE_SHAKING:string = "iceShaking";
    NEAR_WIN_LONG:string = "nearwin";
    NEAR_WIN_REEL:string = "nearwinSweep";
    NEAR_WIN_FAIL:string = "nearwinFail";
    SPIN_ENDS:string = "spinMelodyEnds";
    STICKY_SYMBOL_FREEZE:string = "respinSymbolFreeze";
    RESPIN_ENDS:string = "respinEnds";
    WILD_LANDING:string = "wildLanding";
    WILD_LANDING_IN_ICE:string = "wildLandingInIce";
    WILD_TURNS:string = "wildTurns";
    WILD_TURNS_RESPIN:string = "wildTurnsRespinMode";
    WILD_TURNS_NO_YETI:string = "wildTurnsNoYeti";
    WIND_LOOP:string = "windLoop";
    RESPIN_LEVEL_01:string = "respinSpin1";
    RESPIN_LEVEL_02:string = "respinSpin2";
    RESPIN_LEVEL_03:string = "respinSpin3";
    RESPIN_LEVEL_04:string = "respinSpin4";
    RESPIN_LEVEL_05:string = "respinSpin5";
    STICKY_SYMBOL_ATTENTION_REEL_01:string = "respinHitReel1";
    STICKY_SYMBOL_ATTENTION_REEL_02:string = "respinHitReel2";
    STICKY_SYMBOL_ATTENTION_REEL_03:string = "respinHitReel3";
    STICKY_SYMBOL_ATTENTION_REEL_04:string = "respinHitReel4";
    STICKY_SYMBOL_ATTENTION_REEL_05:string = "respinHitReel5";
    FIREWORK_01:string = "firework1";
    FIREWORK_02:string = "firework2";
    FIREWORK_03:string = "firework3";

    constructor() {
        if(IceIceYetiSoundConfig.instance) {
            throw new Error("IceIceYetiSoundConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}